// extracted by css-extract-rspack-plugin
export default {"form":"ManageBatchCommitTab-module__form__P_Iwa","errorRow":"ManageBatchCommitTab-module__errorRow__cChwi"};